module.exports = __webpack_public_path__ + "static/img/clients_wangfeng.28b3742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/clients_wangfeng.png
// module id = H78+
// module chunks = 2